import PropTypes from 'prop-types';
import React from 'react';
import {connect as connectR} from 'react-redux';
import {Link} from 'react-router';
import _ from 'lodash';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDownload} from '@fortawesome/pro-light-svg-icons';
import {API_SHORT} from '../../../constants';
import translate from '../../translate';
import {LoadTurnoverMonths} from '../../../store/turnoverSlice';
import {REQUEST_PENDING} from '../../../store/network/managedRequest';
import {CORRECTED_ACCOUNTING_STATES} from '../../../util/enums';
import {PbRequest} from '../../../store/pbRequest';

class TurnoverItem extends React.Component {
    static propTypes = {
        year: PropTypes.number.isRequired,
        LoadTurnoverMonths: PropTypes.func.isRequired,
        turnovers: PropTypes.object.isRequired,
        loadMonths: PropTypes.shape({
            status: PropTypes.string.isRequired,
        }).isRequired,
    };

    state = {
        active: false,
        ready: false,
    };

    componentWillMount() {
        if (
            this.props.turnovers &&
            this.props.turnovers.hasOwnProperty(String(this.props.year))
        ) {
            this.setState({ ready: true });
        }
    }

    _toggle = () => {
        if (!this.state.active && !this.props.turnovers[this.props.year]) {
            this.props.LoadTurnoverMonths(this.props.year);
        }
        this.setState({ active: !this.state.active });
    };

    _getMonthWrapper = () => {
        const turnovers = this.props.turnovers[this.props.year];
        if (turnovers && turnovers.length > 0) {
            const leftTurnovers = turnovers.slice(
                0,
                Math.ceil(turnovers.length / 2)
            );
            const rightTurnovers = turnovers.slice(
                Math.ceil(turnovers.length / 2)
            );
            return (
                <ul className="month-wrapper">
                    <div className="col">
                        {_.map(leftTurnovers, (turnover) =>
                            this._renderMonth(turnover)
                        )}
                    </div>
                    <div className="col">
                        {_.map(rightTurnovers, (turnover) =>
                            this._renderMonth(turnover)
                        )}
                    </div>
                </ul>
            );
        } else if (this.props.loadMonths.status === REQUEST_PENDING) {
            return <div className="month-wrapper loading">loading...</div>;
        }
        return null;
    };

    _renderMonth = (turnover) => {
        const total_gross = this.props.strings._utils.formatPrice({
            amount: turnover.total_gross,
            currency: turnover.currency_code,
        });
        const isCorrected = CORRECTED_ACCOUNTING_STATES.includes(
            turnover.accounting_status
        );
        const maybeCorrected =
            isCorrected && `(${this.props.strings.corrected})`;
        return (
            <Link
                to={`${API_SHORT}/v1/turnover/${turnover.credit_note_number}/pdf?downloadToken=${turnover.download_token}`}
                target="_blank"
                key={turnover.month}
            >
                <li key={turnover.month}>
                    {this.props.strings[turnover.month]}: {total_gross}{' '}
                    {maybeCorrected}{' '}
                    <FontAwesomeIcon icon={faDownload} className="color-blue" />
                </li>
            </Link>
        );
    };

    render() {
        const active = this.state.active ? ' active' : '';
        const monthWrapper = this._getMonthWrapper();
        return (
            <ul className="year-wrapper">
                <li className={`year${active}`}>
                    <div className="title " onClick={this._toggle}>
                        <i className="icon icon-wew-arrow-right icon-sm active-indicator" />
                        <span>{this.props.year}</span>
                    </div>
                    {monthWrapper}
                </li>
            </ul>
        );
    }
}

export default connectR(
    (state) => ({
        turnovers: state.turnover.turnovers,
        loadMonths: state.pbRequest[PbRequest.TURNOVER_LOAD_MONTHS],
    }),
    { LoadTurnoverMonths }
)(translate('TurnoverItem')(TurnoverItem));
